<template>
  <popup
    :show.sync="is_popup_show"
    width="500px"
    @on-close="is_popup_show = false"
  >
    <div
      style="padding: 25px 0"
      class="flex flex-direction justify-center align-center"
      v-if="!isSuccess"
    >
      <img
        src="../../../assets/images/patternMaker/accept-image.png"
        style="width: 112px; height: 112px"
        alt=""
      />
      <h1>确认接单？</h1>
      <div
        class="text-666 margin-top-10 text-14 text-center"
        style="width: 335px; line-height: 22px"
      >
        接单后请在约定时间内完成打版并上传平台，逾期将影响您在平台的评分
      </div>
      <div class="flex align-center justify-center" style="margin-top: 40px">
        <button class="cancel-btn cu-btn" @click="is_popup_show = false">
          取消
        </button>
        <button
          class="confirm-btn cu-btn margin-left-10"
          @click="confirmAccept()"
        >
          确认接单
        </button>
      </div>
    </div>
    <div
      style="padding: 30px"
      class="flex flex-direction justify-center align-center"
      v-if="isSuccess"
    >
      <img
        src="../../../assets/images/icon-success-green.png"
        style="width: 64px; height: 64px"
        alt=""
      />
      <h1 class="margin-top-20">接单成功!</h1>
      <div
        class="text-666 margin-top-10 text-14 text-center"
        style="width: 335px; line-height: 22px"
      >
        您已成功承接打版订单，请在约定时间内完成任务
      </div>
      <div class="order-info w100 margin-top-20">
        <div class="flex align-center justify-between">
          <span class="text-666">订单编号：</span>
          <span class="text-333 text-bold">{{ order.make_no }}</span>
        </div>
        <div class="flex align-center justify-between margin-top-20">
          <span class="text-666">交付周期：</span>
          <span class="text-333 text-bold">2026-02-04 23:59 之前</span>
        </div>
      </div>
      <div
        class="flex align-center justify-center w100"
        style="margin-top: 40px"
      >
        <button
          class="confirm-btn cu-btn margin-left-10"
          style="width: 100%"
          @click="confirm()"
        >
          确认
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/Popup.vue";
import { OrderMakeAccept } from "@/api/index.js";
export default {
  name: "Accept",
  data() {
    return {
      is_popup_show: false,
      order: {},
      isSuccess: false,
    };
  },
  components: {
    Popup,
  },
  props: {},
  mounted() {},
  methods: {
    showModal(order) {
      this.order = order;
      this.is_popup_show = true;
    },
    confirmAccept() {
      OrderMakeAccept({
        uuid: this.order.uuid,
      })
        .then(() => {
          this.is_popup_show = false;
          this.$emit("confirm");
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cancel-btn {
  width: 130px;
  height: 44px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e3e3;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.confirm-btn {
  width: 130px;
  height: 44px;
  background: #ff5967;
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}
.order-info {
  padding-top: 24px;
  border-top: 1px dashed #b3b3b3;
}
</style>
